export const genreOptions = ['全部', '武侠', '剧情', '悬疑', '爱情', '奇幻', '冒险', '古装', '动作'];

export const yearOptions = ['全部', '2025', '2024', '2023', '2022'];

export const regionOptions = ['全部', '中国大陆', '中国香港'];

export const sortOptions = [
  { value: 'updated', label: '按更新时间' },
  { value: 'views', label: '按点击量' },
];

export const pageSize = 3;